import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

interface CircleLogoProps {
  src: string;
  size?: number;
  borderColor?: string;
  alt?: string;
  className?: string;
  layoutId?: string;
  onError?: () => void;
}

const CircleLogo: React.FC<CircleLogoProps> = ({
  src,
  size = 80,
  borderColor = "#fb923c",
  alt = "Logo",
  className = "",
  layoutId,
  onError
}) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
    onError?.();
  };
  
  useEffect(() => {
    setImageError(false);
  }, [src]);

  return (
    <motion.div
      layoutId={layoutId} 
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        border: `4px solid ${borderColor}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "white",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        flexShrink: 0, 
        zIndex: 10,
      }}
    >
      {imageError ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff7ed",
            color: borderColor,
            fontSize: size * 0.4,
            fontWeight: "bold",
          }}
        >
          🍽️
        </div>
      ) : (
        <motion.img
          src={src}
          alt={alt}
          layout 
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            display: "block",
          }}
          draggable={false}
          onError={handleImageError}
          loading="lazy"
        />
      )}
    </motion.div>
  );
};

export default CircleLogo;